<!--
 * @Author: xuchen
 * @Date: 2020-03-10 14:31:14
 * @Desc: 企业列表
 -->
<template>
  <div class="enterprise-list-container">
    <div class="result-total-container">
      当前共
      <span class="total-num">{{ total || 0 }}</span>
      条结果
    </div>
    <separate size="12" />
    <div class="enterprise-list-content flex flex-wrap">
      <div
        v-for="item in dataProvider"
        :key="item.enterpriseCode"
        class="enterprise-item"
        @click="handleSelectEnterprise(item.enterpriseCode)"
      >
        <img v-if="!item.url" :src="defaultEnterpriseImg" class="default-enterprise-img" />
        <img v-if="item.url" :src="item.url" alt="企业视频图片" class="img-container" />
        <div v-ellipsis class="enterprise-name">{{ item.enterpriseName }}</div>
      </div>
    </div>
    <div v-if="isShowMore" class="more-data" @click="getMoreData">点击更多</div>
  </div>
</template>

<script>
import Separate from '@/components/Separate/Separate'
import defaultEnterpriseImg from '@/assets/images/enterpriseVideoInspection/enterprise_default.png'

export default {
  name: 'EnterpriseList',
  components: {
    Separate
  },
  props: {
    // 企业列表
    dataProvider: {
      type: Array,
      default: () => []
    },

    // 列表总数
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultEnterpriseImg
    }
  },
  computed: {
    isShowMore() {
      return this.dataProvider.length > 0 && this.total > this.dataProvider.length
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-17 17:17:15
     * @desc 处理选中的企业
     */
    handleSelectEnterprise(key) {
      this.$emit('selectEnterprise', key)
    },

    /**
     * @author xuchen
     * @date 2020-03-17 17:17:06
     * @desc 获取更多数据
     */
    getMoreData() {
      this.$emit('getMoreData')
    }
  }
}
</script>

<style lang="scss" scoped>
.enterprise-list-container {
  .result-total-container {
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.7);
    .total-num {
      font-weight: bold;
      color: rgba(0, 0, 0, 0.7);
    }
  }
  .enterprise-list-content {
    .enterprise-item {
      position: relative;
      width: 298px;
      height: 184px;
      margin-right: 12px;
      margin-bottom: 12px;
      box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
      cursor: pointer;
      &:hover {
        opacity: 0.9;
        box-shadow: 0 0 2px rgba(0, 0, 0, 0.6);
      }
      background-color: #ebebeb;
    }
    .img-container {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    .default-enterprise-img {
      width: 100%;
      height: 100%;
      object-fit: none;
    }
    .enterprise-name {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding-left: 24px;
      background: #000;
      opacity: 0.8;
      color: #fff;
    }
  }
  .more-data {
    padding: 5px 0;
    margin: 20px 0 30px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.05);
    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 1;
    }
  }
}
</style>
